module.exports = __webpack_public_path__ + "img/infogray.31469c9a.svg";